export default __webpack_public_path__ + "static/media/connect-dashboard.de6dad09.png";